import styled from 'styled-components';

const Wrapper = styled.main`
    .empty {
        text-align: center;
        h2 {
            margin-bottom: 1rem;
            text-transform: none;
        }
    }
    .cart-page-btn{
        margin-top: 20px;
    }
`;
export default Wrapper;
